module.exports = __webpack_public_path__ + "media/assets/images/flags/az-48fbd62f0471001d989464ddc00ed34c.svg";